<template>
  <div class="nopads">
      <!-- Header of collapsable item -->
      <div class="col-12 d-flex justify-content-between align-items-center pb-1">
          <div class="flex-grow-1">
              <h4 class="form-header pointer hover-header" @click.stop="tripsVisible = !tripsVisible">
                {{ $t('daily_summary.title') }} ({{ trips.length }})
              </h4>
              <span class="tip-light">{{ $t('contract_reports.trips_hint') }}</span>
          </div>
          <div
              v-if="loading"
              id="loader"
              class="spinner-section"
          />
          <div v-else class="ms-2 px-2" @click.stop="tripsVisible = !tripsVisible">
              <font-awesome-icon icon="arrow-down" class="pointer no-focus arrow-icon dont-print hover-header" :class="{ rotated:tripsVisible }"/>
          </div>
      </div>
      <!-- Collapsable content -->
      <div class="routa-collapse" :class="{ collapsed: tripsVisible }">
          <contract-trip-summary-charts
              ref="charts"
              :results="trips"
              class="show-print"
              :class="{'hidden-charts': !tripsVisible}"
          />
          <contract-trip-summary-list
              :summaries="trips"
              :params="tripParams"
              :user="user"
              :invoice-state-options="invoiceStateOptions"
              @row-selected="showTripDetails"
              @deliveryTonsClicked="showTripDeliveries"
              @loading="tripsLoading"
          />
          <contract-trip-details
              v-if="tripDetailsRow && showDetails"
              :summary-item="tripDetailsRow"
              :trip-table="trips"
              @close="tripDetailsRow = null"
          />
        <contract-trip-deliveries
            v-if="tripDetailsRow && showDeliveries"
            @close="showDeliveries = false"
            :summary-item="tripDetailsRow"
        />
    </div>
    <hr class="report-divider nopads">
  </div>
</template>

<script>
import {timeUtils} from "@/components/mixins/TimeUtils";
import ContractTripSummaryList from "@/components/tripsummary/ContractTripSummaryList";
import ContractTripSummaryCharts from "@/components/tripsummary/ContractTripSummaryCharts";
import {restApi} from "@/components/mixins/RestApiMixin";
import ContractTripDetails from "../tripsummary/ContractTripDetails";
import ContractTripDeliveries from "@/components/tripsummary/ContractTripDeliveries.vue";

export default {
    name: "ContractReportTrips",
    mixins: [timeUtils, restApi],
    components: {ContractTripDeliveries, ContractTripDetails, ContractTripSummaryCharts, ContractTripSummaryList},
    props: {
        searchParams: {
            type: Object,
            default() {
                return null
            }
        },
        user: {
            type: Object,
            default: null
        },
        invoiceStateOptions: {
            type: Array,
            default() {
                return []
            }
        },
    },
    data: function () {
        return {
            loading: false,
            tripsVisible: false,
            showDeliveries: false,
            showDetails: false,
            unit: '',
            trips: [],
            tripParams: null,
            tripDetailsRow: null,
            fields: [
                {date: {label: this.$t('delivery_note.date'), sortable: true}},
                {id: {label: this.$t('common.id'), sortable: true}},
                {vehicle: {label: this.$t('delivery_note.vehicle'), sortable: true}},
                {company: {label: this.$t('daily_summary.company'), sortable: true}},
                {material: {label: this.$t('delivery_note.material'), sortable: true}},
                {type_test_code: {label: this.$t('material_station.material.type_test_code'), sortable: true}},
                {station: {label: this.$t('material_station.title'), sortable: true}},
                {station_company: {label: this.$t('material_station.station_owner'), sortable: true}},
                {amount: {label: this.$t('delivery_note.amount'), sortable: true}},
                {unit: {label: this.$t('delivery_note.unit')}},
                {show_unload_records: {label: this.$t('contract_reports.unload_records.title')}}
            ]
        }
    },
    watch: {
        searchParams: function () {
            this.fetchTrips()
        }
    },
    created() {
        this.fetchTrips()
    },
    methods: {
        fetchTrips: function () {
            if (this.searchParams && this.searchParams.dateTo && this.searchParams.dateFrom && this.searchParams.contract) {
                this.trips = []
                this.$emit('loading', true)
                this.loading = true
                this.tripParams = {
                    to: this.getDateIsoString(new Date(this.searchParams.dateTo)),
                    from: this.getDateIsoString(new Date(this.searchParams.dateFrom)),
                    contract: this.searchParams.contract,
                    orderDetails: 1
                }
                this.restFetchParams(this.contractDailyTripSummaryUrl, this.tripParams, this.handleTripSuccess, this.tripsFail)
            }
        },
        handleTripSuccess: function (response) {
            this.$emit('loading', false)
            this.loading = false
            this.trips = response.data
            this.$emit('tripsSuccess', this.trips)
        },
        tripsFail: function () {
            this.$emit('loading', false)
            this.loading = false
        },
        tripsLoading(loading) {
            this.$emit('loading', loading)
        },
        showTripDetails: function (selectedRow){
            this.tripDetailsRow = selectedRow
            this.showDetails = true
        },
        showTripDeliveries: function (selectedRow){
            this.tripDetailsRow = selectedRow
            this.showDeliveries = true
        }
    }
}
</script>
